
import Select from 'react-select'
import React, { useEffect, useState } from 'react'
import { useSearchParams } from 'react-router-dom'
import Header from '../../../../../../Components/Header/Header'
import Sidebar from '../../../../../../Components/Sidebar/Sidebar'
import DeletePopup from '../../../GardenPopup/DeletePopup'
import WTPBedNumberMasterPagePopup from './WTPBedMasterPagePopup'
import { useAuthState } from '../../../../../../Helper/Context'
import { useDispatch, useSelector } from 'react-redux'
import { WTPFilterBatteryNoDDL } from '../../../../../../Components/CommonDDL/WTPFilterBatteryNoDDL'
import { BedMasterDeleteAPI, BedMasterTableDataAPI, BedMasterTableExportDataAPI } from '../../../../../../Redux/WTPDashboardSlice/WTPDashboardsSlice/WTPMasterData/BedMasterSlice'
import { WTPBedNumberDDLData } from '../../../../../../Components/CommonDDL/WTPBedNumberDDLData'
import { Pegination } from '../../../../../../Components/Pegination/Pegination'
import { WTPBedMasterExportData } from './WTPBedMasterExportPage'

export default function WTPBedNumberMasterPage() {

    const userDetails = useAuthState();
    const { UserID, token, } = userDetails.user
    const dispatch = useDispatch()

    const [searchParams] = useSearchParams()
    let HYear = searchParams.get("Year")
    let YLable = searchParams.get("YLable")
    let HMonth = searchParams.get("Month")
    let MLable = searchParams.get("MLable")
    let HWard = searchParams.get("WardName")
    let WLable = searchParams.get("WLable")
    let ProjectTypeId = searchParams.get("ProjectTypeId")
    let DashProjectTypeId = searchParams.get("DashProjectTypeId")
    let DashboardName = searchParams.get("DashboardName")

    // ----------pagination-------------
    const [PerPageCount, setPerPageCount] = useState(10)
    const [TotalCount, setTotalCount] = useState(0)
    const [To, setTo] = useState(10)
    const [From, setFrom] = useState(1)
    const [rowNo, setrowNo] = useState(1)
    const [CurrentPage, setCurrentPage] = useState(0)

    const [isSearch, setIsSearch] = useState(false)
    const [IsClear, setIsClear] = useState(false)
    const [IsPost, setIsPost] = useState(false)
    const [YearValue, setYearValue] = useState(0)
    const [ImagePopUpData, setImagePopUpData] = React.useState('')
    const [showImagePopup, setshowImagePopup] = React.useState(false)
    const [LocationMasterPopupShow, setLocationMasterPopupShow] = useState(false)
    const [DeletePopupShow, setDeletePopupShow] = useState()
    const [WTPBedNumberMasterPagePopupShow, setWTPBedNumberMasterPagePopupShow] = useState()
    const [apiFlag, setapiFlag] = useState('')
    const [rowData, setrowData] = useState('')

    const [FilterBatteryNo, setFilterBatteryNo] = useState({
        DDL: [],
        ID: 0,
        Label: "Select...",
    })

    const [BedNo, setBedNo] = useState({
        DDL: [],
        ID: 0,
        Label: "Select...",
    })

    const handleAddOnClick = () => {
        setapiFlag('Insert')
        setWTPBedNumberMasterPagePopupShow(true)
    }

    const handleEditOnClick = (item) => {
        setWTPBedNumberMasterPagePopupShow(true)
        setapiFlag('Update')
        setrowData(item)
    }

    const handleOnCloseClick = () => {
        setWTPBedNumberMasterPagePopupShow(false)
    }

    const handleClear = () => {
        setTo(10)
        setFrom(1)
        setCurrentPage(0)
        setIsClear(!IsClear)

        setFilterBatteryNo({
            ...FilterBatteryNo,
            ID: 0,
            Label: 'Select...',
        })
        setBedNo({
            ...BedNo,
            ID: 0,
            Label: 'Select...',
        })
    }

    const handleSearch = () => {
        setCurrentPage(0)
        setTo(10)
        setFrom(1)
        setIsSearch(!isSearch)
    }
    const handleIsPost = () => {
        setIsPost(!IsPost)
    }

    useEffect(() => {
        const data = {
            M_WTP_BedMasterID: BedNo.ID,
            M_WTP_FilterBatteryNoID: FilterBatteryNo.ID,
            M_UserID: UserID,
            token: token,
            From: From,
            To: To,
        }
        dispatch(BedMasterTableDataAPI({ data }))
    }, [IsPost, To, isSearch, IsClear])
    const { tableData, isLoading } = useSelector(state => state.BedMasterTableData)

    useEffect(() => {
        const data = {
            M_WTP_BedMasterID: BedNo.ID,
            M_WTP_FilterBatteryNoID: FilterBatteryNo.ID,
            M_UserID: UserID,
            token: token,
            From: '1',
            To: '99999',
        }
        dispatch(BedMasterTableExportDataAPI({ data }))
    }, [IsPost, isSearch, IsClear])
    const { ExportTableData, isExportLoading } = useSelector(state => state.BedMasterTableExportData)

    const handleDeleteApi = (item) => {
        const data = {
            M_WTP_BedMasterID: item.m_wtP_BedMasterID,
            M_UserID: UserID,
            token: token,
            // Flag: 'Delete',
            handleIsPost: handleIsPost
        }

        dispatch(BedMasterDeleteAPI({ data }))
    }
    const { isDeleteLoading } = useSelector(state => state.BedMasterDeleteData)


    return (
        <div>
            <Header
                MLable={MLable}
                HMonth={HMonth}
                YLable={YLable}
                HYear={HYear}
                HWard={HWard}
                WLable={WLable}
                flag='Screen'
                DashboardName={DashboardName} />
            <div className="wrapper">
                <Sidebar ProjectTypeId={ProjectTypeId}
                    DashProjectTypeId={DashProjectTypeId} />
                <div className="content">
                    {/* <!-- [ breadcrumb ] start --> */}
                    {/* <!-- [ Main Content ] start --> */}
                    <div className='data_mob'>
                        <div className="row m-1 pb-4 master_border">
                            <div className='mt-2'>
                                <h5>Bed Number Master</h5>
                                <div className="float-end butt">
                                {
                                        isExportLoading ?
                                            <button type="button" className="btn btn-primary float-end mr-1 mb-1 ml-1" disabled>
                                                <i
                                                    className="fa fa-refresh fa-spin"
                                                    style={{ marginRight: "5px" }}
                                                />Loading</button>
                                            :
                                            ExportTableData && ExportTableData.table && ExportTableData.table.length > 0 &&
                                            <WTPBedMasterExportData
                                                ExcelData={ExportTableData}
                                                name='Bed Number Master'
                                            // searchName={searchName}
                                            />
                                    }
                                    <i className="fa-solid fa-plus float-end btn btn-secondary"
                                        style={{ color: "white" }}
                                        onClick={handleAddOnClick}
                                    >
                                        <text className="ml-2 poppins">Add</text>
                                    </i>
                                </div>
                            </div>
                            <div className="row m-0 pt-1">
                                <div className="col-12 py-0 rounded rounded-2 shadow"
                                    style={{ border: "1px solid #00000024", background: "#27466317" }}>
                                    <div className="col-12">
                                        <div className="row py-1 rounded2">

                                            <div className="col-lg-3 col-md-6">
                                                <WTPFilterBatteryNoDDL
                                                    FilterBatteryNo={FilterBatteryNo}
                                                    setFilterBatteryNo={setFilterBatteryNo}
                                                    IsPost={IsPost}
                                                />
                                            </div>

                                            <div className="col-lg-3 col-md-6">
                                                <WTPBedNumberDDLData
                                                    BedNo={BedNo}
                                                    setBedNo={setBedNo}
                                                    FilterBatteryNo={FilterBatteryNo}
                                                    IsPost={IsPost}
                                                />

                                            </div>

                                            <div className="col-12 col-lg-3 col-md-4 mt-lg-4 mt-md-4 d-md-flex " >
                                                <button type="button"
                                                    className="btn-clear btn btn-primary mx-2"
                                                    onClick={handleSearch}
                                                >
                                                    Search</button>
                                                <button type="button"
                                                    className="btn btn-outline-danger"
                                                    onClick={handleClear}
                                                >
                                                    Clear</button>
                                            </div>

                                        </div>
                                        <div className="row mob_table table-responsive pt-3">

                                            <table id="totalordergenerated"
                                                cellPadding="0"
                                                cellSpacing="0"
                                                border="0"
                                                className="table table-bordered">

                                                <thead>
                                                    <tr>
                                                        <th className="sr_no_col">Sr No.</th>
                                                        <th>Filter Battery No.</th>
                                                        <th>Bed Number</th>
                                                        <th className='action_icon'>Action</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {
                                                        tableData && tableData.table && tableData.table.length > 0 ? tableData.table.map((item) => (
                                                            <tr style={{ width: '100%' }}>
                                                                <td style={{ textAlign: "center" }}>{item.rowNum ? item.rowNum : '-'}</td>
                                                                <td>{item.filterBatteryNo ? item.filterBatteryNo : "-"}</td>
                                                                <td>{item.bedNumber ? item.bedNumber : '-'}</td>

                                                                <td style={{ textAlign: "center", width: '7%' }}>
                                                                    <span >

                                                                        <i className="fa-solid fa-pen-to-square" title='Edit'
                                                                            style={{ cursor: 'pointer' }}
                                                                            onClick={() => handleEditOnClick(item)}
                                                                        >
                                                                        </i>
                                                                    </span>
                                                                    <span>
                                                                        <DeletePopup
                                                                            open={DeletePopupShow}
                                                                            handleDeleteApi={handleDeleteApi}
                                                                            item={item}
                                                                        />
                                                                    </span>
                                                                </td>
                                                            </tr>
                                                        )) :
                                                            <td colSpan={15}>No data found</td>
                                                    }
                                                </tbody>
                                            </table>

                                        </div>
                                        {tableData && tableData.table && tableData.table.length > 0 &&
                                            <Pegination
                                                PerPageCount={PerPageCount}
                                                TotalCount={tableData.table[0].totalCount}
                                                setFrom={setFrom}
                                                setTo={setTo}
                                                setrowNo={setrowNo}
                                                CurrentPage={CurrentPage}
                                                setCurrentPage={setCurrentPage}
                                            />
                                        }
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
                {
                    WTPBedNumberMasterPagePopupShow ?
                        <WTPBedNumberMasterPagePopup
                            open={WTPBedNumberMasterPagePopupShow}
                            handleIsPost={handleIsPost}
                            handleOnCloseClick={handleOnCloseClick}
                            Flag={apiFlag}
                            rowData={rowData}
                        />
                        : <></>
                }
            </div>
        </div>



    )
}